import { Aperture, Camera, File, Flashlight, Microscope, Orbit, Radiation, Shapes, type LucideIcon } from 'lucide-react';
import type { ImageType } from '@/data/imageTypes';

/**
 * An icon for each image Type, in the viewer's Type bar — the user's pick from
 * the app's own icon set (2026-09-24), so they sit beside every other icon and
 * follow the text colour and the theme.
 */
export const TYPE_ICONS: Record<ImageType, LucideIcon> = {
  wsi: Microscope,
  photomicrograph: Aperture,
  gross: Camera,
  electron_microscopy: Orbit,
  immunofluorescence: Flashlight,
  radiography: Radiation,
  document: File,
};

/** "Other": a picture of none of the seven types. */
export const OtherTypeIcon: LucideIcon = Shapes;
